import CoreMenuHomePage from 'src/dispensary/core-menu/home';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(CoreMenuHomePage, CoreMenuLayout);
